var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n<div class=\"col-lg-9 col-sm-12\">\r\n  <div class=\"consumer-discount-branch-application\"></div>\r\n</div>\r\n";
},"useData":true});